import { MotiView } from 'moti';
import { memo } from 'react';
import { View } from 'react-native';
import { useBoardUnit } from '../../functions/useBoardUnit';
import { workshopBoardColors as colors } from '../../workshopBoardColors';
import { BoardColumns, kBoardRowHeight } from './boardColumns';

/** Rows laid out as the table's will be, pulsing while the board loads. */
export const SkeletonRows = memo(
  ({ columns, count }: { columns: BoardColumns; count: number }) => {
    const u = useBoardUnit();
    return (
      <MotiView
        from={{ opacity: 1 }}
        animate={{ opacity: 0.5 }}
        transition={{ type: 'timing', duration: 800, loop: true }}
      >
        {Array.from({ length: count }, (_, row) => (
          <View
            key={row}
            style={{
              height: u(kBoardRowHeight),
              flexDirection: 'row',
              alignItems: 'center',
              borderBottomWidth: 1,
              borderBottomColor: colors.line,
            }}
          >
            {Object.entries(columns).map(([key, column], index) => (
              // The first column is the plate, larger than the rest.
              <View key={key} style={{ flex: column.flex }}>
                <View
                  style={{
                    width: index === 0 ? '70%' : '55%',
                    height: u(index === 0 ? 30 : 22),
                    borderRadius: u(6),
                    backgroundColor: colors.skeleton,
                  }}
                />
              </View>
            ))}
          </View>
        ))}
      </MotiView>
    );
  },
);
